var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breadcrumbs" },
    [
      _vm._l(_vm.trail, function (item) {
        return [
          item.url != null
            ? [
                _c("router-link", { attrs: { to: _vm.link(item.url) } }, [
                  _c("span", [_vm._v(_vm._s(_vm.t(item.title)))]),
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "chevron-right",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M0 0h24v24H0V0z", fill: "none" },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z",
                      },
                    }),
                  ]
                ),
              ]
            : [_c("span", [_vm._v(_vm._s(_vm.t(item.title)))])],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }